export const getRemountKeys = (productActionsNames: string[]) => {
    return productActionsNames.reduce(
        (acc: Record<string, number>, cur: string) => {
            acc[cur] = Math.random()
            return acc
        },
        {}
    )
}
